import {existsSync} from 'node:fs';
import {homedir} from 'node:os';
import {join} from 'node:path';

export const detectShell = (): string => {
  if (process.platform === 'win32') {
    return 'cmd';
  }

  const shell = process.env.SHELL;
  if (shell) {
    if (shell.includes('bash')) return 'bash';
    if (shell.includes('zsh')) return 'zsh';
    if (shell.includes('fish')) return 'fish';
  }

  if (process.env.ZSH_NAME || process.env.ZSH_VERSION) {
    return 'zsh';
  }

  if (process.env.BASH_VERSION) {
    return 'bash';
  }

  if (process.env.FISH_VERSION) {
    return 'fish';
  }

  return 'bash';
};

export const getShellProfile = (shell: string): string | null => {
  const home = homedir();

  switch (shell) {
    case 'bash': {
      if (existsSync(join(home, '.bashrc'))) {
        return join(home, '.bashrc');
      }
      if (existsSync(join(home, '.bash_profile'))) {
        return join(home, '.bash_profile');
      }
      return join(home, '.bashrc');
    }

    case 'zsh':
      return join(home, '.zshrc');

    case 'fish': {
      const fishConfigDir = join(home, '.config', 'fish');
      return join(fishConfigDir, 'config.fish');
    }

    default:
      return null;
  }
};
